import ReduxHelper, { GenericItemReducerAction } from '../../common/store/ReduxHelper';
import { Recipe, RecipeAction, RecipeActionTypes, RECIPE_STORE } from '../../recipe/store/RecipeTypes';
import { RecipeFormAction, RecipeFormState, RECIPE_FORM_STORE } from './types';

const defaultState: RecipeFormState = ReduxHelper.getItemReducerDefaultState(RECIPE_FORM_STORE) as RecipeFormState;

const reducer = (state = defaultState, action: RecipeFormAction): RecipeFormState => {
  if (action.store === RECIPE_STORE) {
    const itemAction = action as RecipeAction;
    switch (itemAction.typs) {
      case RecipeActionTypes.RECIPE_DELETE:
        return defaultState;
      default: break;
    }
  }
  return ReduxHelper.caseItemDefaultReducer(state, action as GenericItemReducerAction<Recipe>, defaultState) as RecipeFormState;
};

export default reducer;
